import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0791a84c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0791a84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0791a84c')) {
      api.createRecord('0791a84c', component.options)
    } else {
      api.reload('0791a84c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0791a84c&scoped=true", function () {
      api.rerender('0791a84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/setup/category/index.vue"
export default component.exports